module.exports = __webpack_public_path__ + "static/media/contrato.91273ce9.svg";